<template>
  <Loader v-if="this.$store.state.isLoading" />
  <div class="row auth-row">
    <div class="col-12 col-lg-5 form-col">
      <p class="auth-already">
        Already have an acoount?
        <span><router-link to="/login"> Login </router-link> </span>
      </p>
      <form @submit.prevent="register">
        <p class="auth-header">Register to VueBlog</p>
        <div class="auth-field">
          <i class="fas fa-user auth-icon"></i>
          <input
            type="text"
            class="auth-input"
            placeholder="Name"
            v-model="name"
          />
        </div>
        <div class="auth-field">
          <i class="fas fa-envelope auth-icon"></i>
          <input
            type="email"
            class="auth-input"
            placeholder="Email"
            v-model="email"
          />
        </div>
        <div class="auth-field">
          <i class="fas fa-unlock auth-icon"></i>
          <input
            type="password"
            class="auth-input"
            placeholder="Password"
            v-model="password"
          />
        </div>
        <div class="auth-field">
          <i class="fas fa-lock auth-icon"></i>
          <input
            type="password"
            class="auth-input"
            placeholder="Confirm Password"
            v-model="confirmPassword"
          />
        </div>
        <p style="color: red" v-if="errorMessage != ''">{{ errorMessage }}</p>
        <button type="submit" class="auth-button">Sign Up</button>
      </form>
    </div>
    <div class="col-7 background-section"></div>
  </div>
</template>


<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import Loader from "../components/Loader.vue";

export default {
  name: "Register",
  components: {
    Loader,
  },
  data() {
    return {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
      errorMessage: "",
    };
  },
  methods: {
    async register() {
      this.$store.commit("setIsLoading", true);
      try {
        if (this.password !== this.confirmPassword) {
          this.errorMessage = "Two passwords are not matching";
        } else {
          const user = await firebase
            .auth()
            .createUserWithEmailAndPassword(this.email, this.password);
          await firebase
            .firestore()
            .collection("users")
            .doc(user.user.uid)
            .set({
              name: this.name,
              email: this.email,
              uid: user.user.uid,
            });
          this.$router.push("/");
        }
      } catch (error) {
        this.errorMessage = error.message;
        console.log(error);
      } finally {
        this.$store.commit("setIsLoading", false);
      }
    },
  },
};
</script>

<style>
</style>